import { impressionRule } from './rules/impression.js';
import { quartilesRule } from './rules/quartiles.js';
import { errorHandlingRule } from './rules/error-handling.js';
import { trackingPixelsRule } from './rules/tracking-pixels.js';
import { timingRule } from './rules/timing.js';
import { skippableRule } from './rules/skippable.js';
import { companionRule } from './rules/companion.js';

const allRules = [
  impressionRule,
  quartilesRule,
  errorHandlingRule,
  trackingPixelsRule,
  timingRule,
  skippableRule,
  companionRule,
];

/**
 * Run all validation rules against the collected session data.
 * Returns { passed, failed, skipped, rules: [{ name, status, message }] }
 */
export function runValidation(sessionData) {
  const results = [];
  let passed = 0;
  let failed = 0;
  let skipped = 0;

  for (const rule of allRules) {
    try {
      const result = rule.check(sessionData);
      results.push({
        id: rule.id,
        name: rule.name,
        description: rule.description,
        status: result.status,  // 'pass' | 'fail' | 'na'
        message: result.message,
      });

      if (result.status === 'pass') passed++;
      else if (result.status === 'fail') failed++;
      else skipped++;
    } catch (e) {
      results.push({
        id: rule.id,
        name: rule.name,
        description: rule.description,
        status: 'fail',
        message: `Rule threw error: ${e.message}`,
      });
      failed++;
    }
  }

  return { passed, failed, skipped, rules: results };
}

export function getRuleCount() {
  return allRules.length;
}
